export function Manufacturing() {
  return (
    <section id="manufacturing" className="section_manufacturing">
      <div className="container-full">
        <div className="content_manufacturing-top">
          <div className="header_divider-wrapper">
            <div data-motion-id="c1163ffc-27dd-dfdf-6010-edf6b9519424" className="divider"></div>
            <div className="badge">
              <div
                data-motion-id="c1163ffc-27dd-dfdf-6010-edf6b9519426"
                className="badge-dot"
              ></div>
              <div data-word-reveal="true">Prototyping research</div>
            </div>
          </div>
          <div className="heading_manufacturing-grid">
            <h2 data-word-reveal="true">Prototyping &amp; production</h2>
            <div
              id="w-node-_7d80dd16-29f3-daa1-a5b0-d803f236416e-d6538631"
              className="manufacturing_image-wrapper"
            >
              <div
                data-motion-id="9cdf75c3-22b0-c241-6e4d-78c785cc39c8"
                className="container_image-small editorial-frame editorial-frame--grey"
              >
                <div
                  data-motion-id="97790906-1540-c8e3-c626-fc8a709fab33"
                  className="image_shading"
                ></div>
                <div
                  data-motion-id="6584abfd-8b42-72ed-6f76-161adedd9760"
                  className="image_shading is-grey"
                ></div>
                <img
                  src="/assets/images/editorial/field-path-512.webp"
                  srcSet="/assets/images/editorial/field-path-256.webp 256w, /assets/images/editorial/field-path-512.webp 512w, /assets/images/editorial/field-path-768.webp 768w"
                  sizes="200px"
                  width="1254"
                  height="1254"
                  loading="lazy"
                  decoding="async"
                  alt="Illustrative rough gravel track beside grass"
                  className="editorial-image"
                />
                <div className="icon-position_top-right">
                  <div className="icon-embed-medium text-color-primary25 w-embed">
                    <svg
                      aria-hidden="true"
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M10 30.0005H0V40.0005H10V30.0005Z" fill="currentColor"></path>
                      <path
                        d="M0 0.000488281V10.0005L20 0.000488281L10 20.0005V10.0005H0V30.0005L20 20.0005L10 40.0005H30V30.0005H20L40 20.0005L30 40.0005H40V0.000488281H0ZM30 20.0005V10.0005H20L40 0.000488281L30 20.0005Z"
                        fill="currentColor"
                      ></path>
                    </svg>
                  </div>
                </div>
              </div>
              <div data-word-reveal="true" className="text-size-tiny">
                Research into the relationship between design, assembly and maintenance in modular
                workspaces.
              </div>
              <span className="editorial-image-label">Illustrative imagery</span>
            </div>
          </div>
        </div>
      </div>
      <div className="manufacturing_content-wrapper">
        <div className="container-full">
          <div className="content_manufacturing-bottom">
            <div className="manufacturing-top">
              <div
                id="w-node-c29bb6d3-8070-a04b-7ce5-bd37a5e8499f-d6538631"
                data-motion-id="c29bb6d3-8070-a04b-7ce5-bd37a5e8499f"
                className="manufacturing_column is-image"
              >
                <img
                  src="/assets/images/Ресурс-12x-100.jpg"
                  srcSet="/assets/images/Ресурс-12x-100-p-800.jpg 800w, /assets/images/Ресурс-12x-100-p-1080.jpg 1080w, /assets/images/Ресурс-12x-100-p-1600.jpg 1600w, /assets/images/Ресурс-12x-100.jpg 2781w"
                  sizes="(max-width: 479px) max(calc(100vw - 32px), 314px), (max-width: 767px) max(calc(100vw - 32px), 502px), (max-width: 991px) max(calc(100vw - 64px), 627px), max(calc((100vw - 80px) / 1.5), 753px)"
                  width="2781"
                  height="2218"
                  loading="lazy"
                  decoding="async"
                  alt="Container manufacturing unit"
                  className="manufacturing-exterior"
                />
                <div
                  data-motion-id="7bd459f9-e71f-eaa6-4901-e2f70f55cbf5"
                  className="image_shading is-black"
                ></div>
                <div
                  data-motion-id="a6978f29-a372-3e54-c47a-e21ffcfcafd9"
                  className="image_shading"
                ></div>
              </div>
              <div className="manufacturing_column"></div>
            </div>
            <div className="manufacturing-bottom">
              <div className="manufacturing_column">
                <div className="manufacturing_column-content">
                  <div className="manufacturing_text">
                    <img src="/assets/images/Shape-26.svg" loading="lazy" alt="" />
                    <h3 data-word-reveal="true" className="manufacturing_heading">
                      Inspection &amp; maintenance
                    </h3>
                    <div data-word-reveal="true" className="text-size-small">
                      Inspection and access are considered early in a design, alongside the ability
                      to identify, maintain and replace components.
                    </div>
                  </div>
                </div>
              </div>
              <div className="manufacturing_column">
                <div className="manufacturing_column-content">
                  <div className="manufacturing_text">
                    <img src="/assets/images/Shape-67.svg" loading="lazy" alt="" />
                    <h3 data-word-reveal="true" className="manufacturing_heading">
                      Repeatable assembly
                    </h3>
                    <div data-word-reveal="true" className="text-size-small">
                      Production research examines how material choices, component interfaces and
                      assembly processes relate to repeatability.
                    </div>
                  </div>
                </div>
              </div>
              <div className="manufacturing_column">
                <div className="manufacturing_column-content">
                  <div className="manufacturing_text">
                    <img src="/assets/images/Shape-39.svg" loading="lazy" alt="" />
                    <h3 data-word-reveal="true" className="manufacturing_heading">
                      Modular workspaces
                    </h3>
                    <div data-word-reveal="true" className="text-size-small">
                      Modular layouts provide a context for studying how prototyping, assembly and
                      maintenance activities fit together.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
